import { Injectable } from '@angular/core';

/**
 * a shared service that can be used across all components to keep track of the state of UI elements.
 */
@Injectable({
  providedIn: 'root'
})
export class UserInterfaceService {
  duplikit = {
    mergeButtonsDisabled: false
  };

  constructor() { }
}
